
import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Card, CardContent } from "@/components/ui/card";
import AdminAnalyticsCharts from './AdminAnalyticsCharts';
import AdminReferralExport from './AdminReferralExport';
import AdminLogViewer from './AdminLogViewer';
import SystemStatusChecker from './SystemStatusChecker';

const AdminStatsTab = () => {
  const [activeTab, setActiveTab] = useState("analytics");
  
  return (
    <Tabs defaultValue={activeTab} value={activeTab} onValueChange={setActiveTab} className="space-y-6">
      <TabsList className="grid grid-cols-4 w-full max-w-[800px]">
        <TabsTrigger value="analytics">Analytics</TabsTrigger>
        <TabsTrigger value="reports">Reports & Export</TabsTrigger>
        <TabsTrigger value="logs">System Logs</TabsTrigger>
        <TabsTrigger value="status">System Status</TabsTrigger>
      </TabsList>
      
      <TabsContent value="analytics">
        <Card>
          <CardContent className="pt-6">
            <AdminAnalyticsCharts />
          </CardContent>
        </Card>
      </TabsContent>
      
      <TabsContent value="reports">
        <AdminReferralExport />
      </TabsContent>
      
      <TabsContent value="logs">
        <AdminLogViewer />
      </TabsContent>
      
      <TabsContent value="status">
        <SystemStatusChecker />
      </TabsContent>
    </Tabs>
  );
};

export default AdminStatsTab;
